export default __webpack_public_path__ + "static/media/keyvisual-bensheim.3594902c.jpg";